import { Component } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ManthrisUi';
  showMenuComponent: boolean = false;
  constructor(private router: Router,) {
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        var new_str = event.url.split("?")[0];

        let isstatusObj = [

          '/',

        ].includes(new_str);

        this.showMenuComponent = !isstatusObj;
      }
    });
   }
}
